import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  AddStaffPermissionsDTO,
  DeleteClinicStaffDTO,
  EditStaffProfileDTO,
  getStaffPermissionsDTO,
  getStaffProfileDTO,
  RegisterStaffPermissionDTO,
  EditStaffDataDTO,
  EditStaffStatusDTO,
  getStaffPerByIdDTO,
  addPharmcyPermissionDTO,
  staffLoginDTO,
  ActiveStatfDTO
} from "../../dtos/staff";
import staffService from "./staffService";

const initialState = {
  staff_id: null,
  clinicStaffPayload: [],
  permissionsPayload: [],
  staffPermissionsPayload: [] ,
  activeStaffPayload: [] as any[],
  staffComponentPayload: [],
  addPermissionsPayload: null,
  addPerByIdPayload: null,
  registerStaffPermissionPayload: null,
  staffLoginPayload: null,
  staffLogoutPayload: null,
  addPharmacyPermissionPayload: null,
  deletePharmacyPermissionPayload: null,
  deleteStaffPayload: null,
  getStaffProfilePayload: null,
  editStaffInfoPayload: null,
  editStaffDataPayload: null,
  staffStatusPayload: null,
  staffPermission: null,

  isStaffError: false,
  isPermissionsError: false,
  isPerByIdError: false,
  isStaffPermissionsError: false,
  isActiveStaffError: false,
  isAddPermissionsError: false,
  isRegisterStaffPermissionError: false,
  isStaffLoginError: false,
  isStaffLogoutError: false,
  isAddPharmacyPermissionError: false,
  isdeletePharmacyPermissionError: false,
  isDeletePermissionsError: false,
  isGetStaffProfileError: false,
  isEditStaffInfoError: false,
  isEditStaffDataError: false,
  isStaffStatusError: false,

  isStaffSuccess: false,
  isPermissionsSuccess: false,
  isPerByIdSuccess: false,
  isStaffPermissionsSuccess: false,
  isActiveStaffSuccess: false,
  isStaffComponentSuccess: false,
  isAddPermissionsSuccess: false,
  isRegisterStaffPermissionSuccess: false,
  isStaffLoginSuccess: false,
  isStaffLogoutSuccess: false,
  isAddPharmacyPermissionSuccess: false,
  isdeletePharmacyPermissionSuccess: false,
  isDeleteStaffSuccess: false,
  isGetStaffProfileSuccess: false,
  isEditStaffInfoSuccess: false,
  isEditStaffDataSuccess: false,
  isStaffStatusSuccess: false,

  isStaffLoading: false,
  isPermissionsLoading: false,
  isPerByIdLoading: false,
  isStaffPermissionsLoading: false,
  isactiveStaffLoading: false,
  isStaffAllComponentLoading: false,
  isAddPermissionsLoading: false,
  isRegisterStaffPermissionLoading: false,
  isStaffLoginLoading: false,
  isStaffLogoutLoading: false,
  isaddPharmacyPermissionLoading: false,
  isdeletePharmacyPermissionLoading: false,
  isDeleteStaffLoading: false,
  isGetStaffProfileLoading: false,
  isEditStaffInfoLoading: false,
  isEditStaffDataLoading: false,
  isStaffStatusLoading: false,

  staffMessage: "",
  permissionsMessage: "",
  staffPermissionsMessage: "",
  activeStaffMessage: "",
  staffComponentMessage: "",
  addPermissionsMessage: "",
  addPerByIdMessage: "",
  registerStaffPermissionMessage: "",
  staffLoginMessage: "",
  staffLogoutMessage: "",
  addPharmacyPermissionMessage: "",
  deletePharmacyPermissionMessage: "",
  deleteStaffMessage: "",
  staffProfileMessage: "",
  editStaffInfoMessage: "",
  editStaffDataMessage: "",
  staffStatusMessage: "",
};

export const getStaffProfile = createAsyncThunk(
  "staff/profile/get",
  async (dto: getStaffProfileDTO, thunkAPI) => {
    try {
      return await staffService.getStaffProfile(dto);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const getAllPharmacyPermission = createAsyncThunk(
  "AllPharmacyPermission/get",
  async ( thunkAPI) => {
    try {
      return await staffService.getAllPharmacyPermission();
    } catch (error: any) {
      
    }
  }
);

export const getClinicStaff = createAsyncThunk(
  "clinic/staff",
  async (id: string, thunkAPI) => {
    try {
      return await staffService.getAllStaff(id);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const deleteClinicStaff = createAsyncThunk(
  "clinic/staff-delete",
  async (dto: DeleteClinicStaffDTO, thunkAPI) => {
    try {
      return await staffService.deleteClinicStaff(dto);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const registerStaffPermission = createAsyncThunk(
  "register/staffPermission",
  async (staffPermission: RegisterStaffPermissionDTO, thunkAPI) => {
    try {
      return await staffService.registerStaffPermission(staffPermission);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const addPharmcyPermission = createAsyncThunk(
  "add/pharmacyPermission",
  async (addPharmcyPermission: addPharmcyPermissionDTO, thunkAPI) => {
    try {
      return await staffService.addPharmcyPermission(addPharmcyPermission);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const deletePharmcyPermission = createAsyncThunk(
  "delete/pharmacyPermission",
  async (deletePharmcyPermission: addPharmcyPermissionDTO, thunkAPI) => {
    try {
      return await staffService.deletePharmcyPermission(deletePharmcyPermission);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const editStaffData = createAsyncThunk(
  "staffData/edit",
  async (dto: EditStaffDataDTO, thunkAPI) => {
    try {
      return await staffService.editStaffData(dto);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const staffStatus = createAsyncThunk(
  "staffStatus/edit",
  async (dto: EditStaffStatusDTO, thunkAPI) => {
    try {
      return await staffService.staffStatus(dto);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getAllStaffPermissions = createAsyncThunk(
  "getAllStaffPermissions", 
  async (id: number, thunkAPI) => {
    try {
      return await staffService.getAllStaffPermissions(id);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);


export const getActiveStaff = createAsyncThunk(
  "get/ActiveStaff", 
  async (activeStaff: ActiveStatfDTO, thunkAPI) => {
    try {
      return await staffService.getActiveStaff(activeStaff);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);


export const getStaffPermissions = createAsyncThunk(
  "staff/permissions/get",
  async (staff: getStaffPermissionsDTO, thunkAPI) => {
    try {
      return await staffService.getStaffPermissions(staff);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getStaffPerById = createAsyncThunk(
  "staffperPerById/get",
  async (staff: getStaffPerByIdDTO, thunkAPI) => {
    try {
      return await staffService.getStaffPerById(staff);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const addPermissions = createAsyncThunk(
  "staff/permissions/add",
  async (dto: AddStaffPermissionsDTO, thunkAPI) => {
    try {
      return await staffService.addPermissions(dto);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const deletePermissions = createAsyncThunk(
  "staff/permissions/delete",
  async (dto: AddStaffPermissionsDTO, thunkAPI) => {
    try {
      return await staffService.deletePermissions(dto);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const editStaffInfo = createAsyncThunk(
  "staff/edit",
  async (dto: EditStaffProfileDTO, thunkAPI) => {
    try {
      return await staffService.editStaffInfo(dto);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);



export const staffLoign = createAsyncThunk(
  "staff/login",
  async (stafflogin: staffLoginDTO, thunkAPI) => {
    try {
      return await staffService.staffLogin(stafflogin);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const staffLogout = createAsyncThunk(
  "staff/logout",
  async (stafflogout: any, thunkAPI) => {
    try {
      return await staffService.staffLogout(stafflogout);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);


export const staffSlice = createSlice({
  name: "staff/Permissions",
  initialState,
  reducers: {
    reset: () => initialState,
    AddStaffId: (state, action) => {
      state.staff_id = action.payload;
    },
  },
  
  extraReducers: (builder) => {
    builder

    .addCase(getAllPharmacyPermission.pending, (state) => {
      state.isStaffAllComponentLoading = true;
    })
    .addCase(getAllPharmacyPermission.fulfilled, (state, action) => {
      state.isStaffAllComponentLoading = false;
      state.isStaffComponentSuccess = true;
      state.staffComponentMessage = "";
      state.staffComponentPayload = action.payload;
    })
    .addCase(
      getAllPharmacyPermission.rejected,
      (state, action: PayloadAction<any>) => {
        state.isStaffAllComponentLoading = false;
        state.isStaffPermissionsError = true;
        state.staffComponentMessage = action.payload;
      }
    )
      .addCase(registerStaffPermission.pending, (state) => {
        state.isRegisterStaffPermissionLoading = true;
      })
      .addCase(registerStaffPermission.fulfilled, (state, action) => {
        state.isRegisterStaffPermissionLoading = false;
        state.isRegisterStaffPermissionSuccess = true;
        state.registerStaffPermissionMessage = "";
        state.registerStaffPermissionPayload = action.payload;
      })
      .addCase(registerStaffPermission.rejected, (state, action: PayloadAction<any>) => {
        state.isRegisterStaffPermissionLoading = false;
        state.isRegisterStaffPermissionError = true;
        state.registerStaffPermissionMessage = action.payload;
      })


      .addCase(addPharmcyPermission.pending, (state) => {
        state.isaddPharmacyPermissionLoading = true;
      })
      .addCase(addPharmcyPermission.fulfilled, (state, action) => {
        state.isaddPharmacyPermissionLoading = false;
        state.isAddPharmacyPermissionSuccess = true;
        state.addPharmacyPermissionMessage = "";
        state.addPharmacyPermissionPayload = action.payload;
      })
      .addCase(addPharmcyPermission.rejected, (state, action: PayloadAction<any>) => {
        state.isaddPharmacyPermissionLoading = false;
        state.isAddPharmacyPermissionError = true;
        state.addPharmacyPermissionMessage = action.payload;
      })

      .addCase(deletePharmcyPermission.pending, (state) => {
        state.isdeletePharmacyPermissionLoading = true;
      })
      .addCase(deletePharmcyPermission.fulfilled, (state, action) => {
        state.isdeletePharmacyPermissionLoading = false;
        state.isdeletePharmacyPermissionSuccess = true;
        state.deletePharmacyPermissionMessage = "";
        state.deletePharmacyPermissionPayload = action.payload;
      })
      .addCase(deletePharmcyPermission.rejected, (state, action: PayloadAction<any>) => {
        state.isdeletePharmacyPermissionLoading = false;
        state.isdeletePharmacyPermissionError = true;
        state.deletePharmacyPermissionMessage = action.payload;
      })

      .addCase(editStaffData.pending, (state) => {
        state.isEditStaffDataLoading = true;
      })
      .addCase(editStaffData.fulfilled, (state, action) => {
        state.isEditStaffDataLoading = false;
        state.isEditStaffDataSuccess = true;
        state.isEditStaffDataError = false;
        state.editStaffDataMessage = "";
        state.editStaffDataPayload = action.payload;
      })
      .addCase(editStaffData.rejected, (state, action: PayloadAction<any>) => {
        state.isEditStaffDataLoading = false;
        state.isEditStaffDataError = true;
        state.editStaffDataMessage = action.payload;
      })

      .addCase(staffStatus.pending, (state) => {
        state.isStaffStatusLoading = true;
      })
      .addCase(staffStatus.fulfilled, (state, action) => {
        state.isStaffStatusLoading = false;
        state.isStaffStatusSuccess = true;
        state.isStaffStatusError = false;
        state.staffStatusMessage = "";
        state.staffStatusPayload = action.payload;
      })
      .addCase(staffStatus.rejected, (state, action: PayloadAction<any>) => {
        state.isStaffStatusLoading = false;
        state.isStaffStatusError = true;
        state.staffStatusMessage = action.payload;
      })

      .addCase(getAllStaffPermissions.pending, (state) => {
        state.isStaffPermissionsLoading = true;
      })
      .addCase(getAllStaffPermissions.fulfilled, (state, action) => {
        state.isStaffPermissionsLoading = false;
        state.isStaffPermissionsSuccess = true;
        state.staffPermissionsMessage = "";
        state.staffPermissionsPayload = action.payload;
      })
      .addCase(
        getAllStaffPermissions.rejected,
        (state, action: PayloadAction<any>) => {
          state.isStaffPermissionsLoading = false;
          state.isStaffPermissionsError = true;
          state.staffPermissionsMessage = action.payload;
        }
      )

      .addCase(getActiveStaff.pending, (state) => {
        state.isactiveStaffLoading = true;
      })
      .addCase(getActiveStaff.fulfilled, (state, action) => {
        state.isactiveStaffLoading = false;
        state.isActiveStaffSuccess = true;
        state.activeStaffMessage = "";
        state.activeStaffPayload = action.payload;
      })
      .addCase(
        getActiveStaff.rejected,
        (state, action: PayloadAction<any>) => {
          state.isactiveStaffLoading = false;
          state.isActiveStaffError = true;
          state.activeStaffMessage = action.payload;
        }
      )

      .addCase(getClinicStaff.pending, (state) => {
        state.isStaffLoading = true;
      })
      .addCase(getClinicStaff.fulfilled, (state, action) => {
        state.isStaffLoading = false;
        state.isStaffSuccess = true;
        state.staffMessage = "";
        state.clinicStaffPayload = action.payload;
      })
      .addCase(getClinicStaff.rejected, (state, action: PayloadAction<any>) => {
        state.isStaffLoading = false;
        state.isStaffError = true;
        state.staffMessage = action.payload;
      })
      .addCase(getStaffPermissions.pending, (state) => {
        state.isPermissionsLoading = true;
      })
      .addCase(getStaffPermissions.fulfilled, (state, action) => {
        state.isPermissionsLoading = false;
        state.isPermissionsSuccess = true;
        state.permissionsMessage = "";
        state.permissionsPayload = action.payload;
      })
      .addCase(
        getStaffPermissions.rejected,
        (state, action: PayloadAction<any>) => {
          state.isPermissionsLoading = false;
          state.isPermissionsError = true;
          state.permissionsMessage = action.payload;
        }
      )

      .addCase(getStaffPerById.pending, (state) => {
        state.isPerByIdLoading = true;
      })
      .addCase(getStaffPerById.fulfilled, (state, action) => {
        state.isPerByIdLoading = false;
        state.isPerByIdSuccess = true;
        state.addPerByIdMessage = "";
        state.staffPermission = action.payload;
      })
      .addCase(
        getStaffPerById.rejected,
        (state, action: PayloadAction<any>) => {
          state.isPerByIdLoading = false;
          state.isPerByIdError = true;
          state.addPerByIdMessage = action.payload;
        }
      )
      .addCase(addPermissions.pending, (state) => {
        state.isAddPermissionsLoading = true;
      })
      .addCase(addPermissions.fulfilled, (state, action) => {
        state.isAddPermissionsLoading = false;
        state.isAddPermissionsSuccess = true;
        state.addPermissionsMessage = "";
        state.addPermissionsPayload = action.payload;
      })
      .addCase(addPermissions.rejected, (state, action: PayloadAction<any>) => {
        state.isAddPermissionsLoading = false;
        state.isAddPermissionsError = true;
        state.addPermissionsMessage = action.payload;
      })
      .addCase(deletePermissions.pending, (state) => {
        state.isDeletePermissionsError = true;
      })
      .addCase(deletePermissions.fulfilled, (state, action) => {
        state.isDeletePermissionsError = false;
        state.isDeleteStaffSuccess = true;
        state.deleteStaffMessage = "";
        state.deleteStaffPayload = action.payload;
      })
      .addCase(
        deletePermissions.rejected,
        (state, action: PayloadAction<any>) => {
          state.isDeleteStaffLoading = false;
          state.isDeletePermissionsError = true;
          state.deleteStaffMessage = action.payload;
        }
      )
      .addCase(getStaffProfile.pending, (state) => {
        state.isGetStaffProfileLoading = true;
      })
      .addCase(getStaffProfile.fulfilled, (state, action) => {
        state.isGetStaffProfileLoading = false;
        state.isGetStaffProfileSuccess = true;
        state.isGetStaffProfileError = false;
        state.staffProfileMessage = "";
        state.getStaffProfilePayload = action.payload;
      })
      .addCase(
        getStaffProfile.rejected,
        (state, action: PayloadAction<any>) => {
          state.isGetStaffProfileLoading = false;
          state.isGetStaffProfileError = true;
          state.staffProfileMessage = action.payload;
        }
      )
      .addCase(editStaffInfo.pending, (state) => {
        state.isEditStaffInfoLoading = true;
      })
      .addCase(editStaffInfo.fulfilled, (state, action) => {
        state.isEditStaffInfoLoading = false;
        state.isEditStaffInfoSuccess = true;
        state.isEditStaffInfoError = false;
        state.editStaffInfoMessage = "";
        state.editStaffInfoPayload = action.payload;
      })
      .addCase(editStaffInfo.rejected, (state, action: PayloadAction<any>) => {
        state.isEditStaffInfoLoading = false;
        state.isEditStaffInfoError = true;
        state.editStaffInfoMessage = action.payload;
      })
      .addCase(staffLoign.pending, (state) => {
        state.isStaffLoginLoading = true;
      })
      .addCase(staffLoign.fulfilled, (state, action) => {
        state.isStaffLoginLoading = false;
        state.isStaffLoginSuccess = true;
        state.staffLoginMessage = "";
        state.staffLoginPayload = action.payload;
      })
      .addCase(staffLoign.rejected, (state, action: PayloadAction<any>) => {
        state.isStaffLoginLoading = false;
        state.isStaffLoginError = true;
        state.staffLoginMessage = action.payload;
      })

      .addCase(staffLogout.pending, (state) => {
        state.isStaffLogoutLoading = true;
      })
      .addCase(staffLogout.fulfilled, (state, action) => {
        state.isStaffLogoutLoading = false;
        state.isStaffLogoutSuccess = true;
        state.staffLogoutMessage = "";
        state.staffLogoutPayload = action.payload;
      })
      .addCase(staffLogout.rejected, (state, action: PayloadAction<any>) => {
        state.isStaffLogoutLoading = false;
        state.isStaffLogoutError = true;
        state.staffLogoutMessage = action.payload;
      })
  },
});

export const { reset , AddStaffId } = staffSlice.actions;
export default staffSlice.reducer;
